
<section class="mt-1 mb-3 rounded m-auto w-100" id="section" >

  @if (contextLicenseFree) {
    <div
      class="alert alert-warning d-flex align-items-center mb-4"
      role="alert"
      data-nar="form-widget-infobox"
      style="gap: 8px;"
      >
      <mat-icon class="material-symbols-outlined">warning</mat-icon>
      <span>
        {{'free_publisher.form_warning' | translate}}
      </span>
    </div>
  }


  <form [formGroup]="formEditForm" class="mb-2">

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{'pass.name' | translate}}</mat-label>
      <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}" data-nar="form-widget-name">
    </mat-form-field>

    <div class="d-flex flex-row">
      <div class="pe-2 flex-grow-1">
        <div class="input-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.title' | translate}}</mat-label>
            <input formControlName="title" type="text" matInput placeholder="{{'pass.title' | translate}}" data-nar="form-widget-title">
          </mat-form-field>
        </div>
      </div>
      <div class="ps-2 flex-grow-1">
        <div class="input-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.subtitle' | translate}}</mat-label>
            <input formControlName="subtitle" type="text" matInput placeholder="{{'pass.subtitle' | translate}}" data-nar="form-widget-subtitle">
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="d-flex flex-row">
      <div class="pe-2 flex-grow-1">
        <div class="input-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.submitTitle' | translate}}</mat-label>
            <input formControlName="submitTitle" type="text" matInput placeholder="{{'pass.submitTitle' | translate}}" data-nar="form-widget-submit">
          </mat-form-field>
        </div>
      </div>
      <div class="ps-2 flex-grow-1">
        <div class="input-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.submitAgainTitle' | translate}}</mat-label>
            <input formControlName="submitAgainTitle" type="text" matInput placeholder="{{'pass.submitAgainTitle' | translate}}" data-nar="form-widget-submit-again">
          </mat-form-field>
        </div>
      </div>
    </div>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{'pass.successMessage' | translate}}</mat-label>
      <input formControlName="successMessage" type="text" matInput placeholder="{{'pass.successMessage' | translate}}" data-nar="form-widget-submit-success">
      <mat-hint>{{'pass.successMessageHint' | translate}}</mat-hint>
    </mat-form-field>

    <div class="form-control p-3 my-3 d-flex justify-content-between w-100">
      <!-- translation fehlt -->
      <label for="value">{{'pass.form.reloadDPP' | translate}}</label>
      <mat-slide-toggle class="ms-5 example-margin" formControlName="reloadDPP"></mat-slide-toggle>
    </div>

    @if (workflows && workflows.length > 0) {
      <mat-form-field appearance="outline" class="w-100 mt-3">
        <mat-label>{{'workflow.title' | translate}}</mat-label>
        <mat-select formControlName="workflowTemplateId">
          <mat-option value=""> - </mat-option>
          @for (workflow of workflows; track workflow.id) {
            <mat-option [value]="workflow.id">{{workflow.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-tab-group class="mt-3">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="material-symbols-outlined me-2">view_stream</mat-icon>  {{'pass.form.manage_sections' | translate}}
        </ng-template>
        <div class="p-2 mt-3">
          <button mat-button class="secondary-gray-button my-2" (click)="addSection();" [disabled]="translationModeOriginal || data.translateMode">
            <mat-icon>add_circle</mat-icon> {{'taskTemplates.wt_section'  | translate}}
          </button>

          <div class="my-3">
            <mat-accordion class="form-field-section" multi>
              @for (section of sectionsEdit; track section.id; let sectionIndex = $index) {
                <mat-expansion-panel [expanded]="sectionIndex === 0" (opened)="panelOpenState = true" (closed)="panelOpenState = false" data-nar="form-widget-section-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title >
                      @if (section.title) {
                        <span style="color:var(--warmOrange);">{{section.title ? section.title : 'pass.newSection' | translate}} </span>
                      }
                      @if (!section.title) {
                        <span class="text-muted">{{'pass.newSection' | translate}} </span>
                      }
                    </mat-panel-title>
                    <mat-panel-description style="flex-grow: 0;">
                      <button mat-icon-button [matMenuTriggerFor]="editDelete" style="color:var(--warmOrange);" (click)="$event.stopPropagation()">
                        <mat-icon data-nar="form-widget-section-edit">more_vert</mat-icon>
                      </button>
                      <mat-menu #editDelete="matMenu">
                        <button mat-menu-item (click)="editTitleSection(section.id,section.title, sectionIndex)"  [disabled]="translationModeOriginal">
                          <mat-icon>edit</mat-icon> {{"taskTemplates.editSectionTitle" | translate}}
                        </button>
                        <!-- <button mat-menu-item (click)="duplicateSection(section, sectionIndex);" ><mat-icon>content_copy</mat-icon> {{"taskTemplates.duplicateSection" | translate}}</button> -->
                        <button mat-menu-item (click)="deleteSection(section.title, sectionIndex);" style="margin-left: 0" class="delete-button" [disabled]="translationModeOriginal || data.translateMode">
                          <mat-icon class="material-symbols-outlined">delete</mat-icon> {{"taskTemplates.deleteSection" | translate}}
                        </button>
                      </mat-menu>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <mat-action-row>
                    <button mat-button class="secondary-gray-button my-2" [matMenuTriggerFor]="fieldTypes"  data-nar="form-widget-add-element">
                      <mat-icon>add_circle</mat-icon> {{'workTask.addNewElement' | translate}}
                    </button>
                    <mat-menu #fieldTypes="matMenu">
                      @for (fieldType of fieldOptions; track fieldType.type) {
                        <button mat-menu-item (click)="addFieldToSection(fieldType.type, sectionIndex);" data-nar="form-widget-field-type" [disabled]="translationModeOriginal || data.translateMode">{{fieldType.translations | translate}} </button>
                      }
                    </mat-menu>
                  </mat-action-row>
                  @if (section.fields) {
                    <div class="list-group" cdkDropList (cdkDropListDropped)="drop($event,sectionIndex)">
                      @for (field of section.fields; track field.id; let fieldIndex = $index) {
                        <div class="list-group-item" style="padding: 2px 0;" cdkDrag>
                          <div class="d-flex flex-row justify-content-between align-items-center">
                            <div class="d-flex flex-row flex-wrap" (click)="openFieldDialog(field, fieldIndex, sectionIndex, section.id)" >
                              <span class="material-symbols-outlined p-2" style="color:var(--warmOrange);">
                                @if(field.type=='text') {text_format}
                                  @if(field.type=='longText') {subject}
                                    @if(field.type=='number') {pin}
                                      @if(field.type=='decimal') {numbers}
                                        @if(field.type=='date') {today}
                                          @if(field.type=='time') {schedule}
                                            @if(field.type=='dateTime') {calendar_month}
                                              @if(field.type=='boolean') {toggle_on}
                                                @if(field.type=='options') {list}
                                                  @if(field.type=='map') {map}
                                                  </span>
                                                  <div class="ps-1 d-flex flex-column justify-content-center">
                                                    <span data-nar="form-widget-list-element">{{field.title}} @if (field.mandatory) {
                                                      <span>*</span>
                                                    }</span>
                                                    <span class="text-muted" style="font-size: 11px;">{{field.key}}</span>
                                                  </div>
                                                </div>
                                                <button mat-icon-button class="delete-button" (click)="deleteField(field, fieldIndex, sectionIndex);" [disabled]="translationModeOriginal || data.translateMode">
                                                  <span class="material-symbols-outlined"> delete  </span>
                                                </button>
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      }
                                    </mat-expansion-panel>
                                  }
                                </mat-accordion>
                              </div>
                            </div>
                          </mat-tab>
                          <mat-tab>
                            <ng-template mat-tab-label>
                              <mat-icon class="material-symbols-outlined me-2">palette</mat-icon>  {{'pass.form.btn_form_style' | translate}}
                            </ng-template>
                            <div class="p-2 my-3">
                              <!-- <form [formGroup]="submitButtonStyleForm"> -->

                              <div class="d-flex flex-row">

                                <mat-form-field appearance="outline" class="w-50 pe-1">
                                  <mat-label>{{'pass.buttons.borderWidth' | translate}}</mat-label>
                                  <input formControlName="submitButtonStyle_borderWidth" type="number" step="0.1" matInput min="0" placeholder="{{'pass.buttons.borderWidth' | translate}}" data-nar="form-widget-button-border-width">
                                  <span matSuffix class="p-3"> px</span>
                                </mat-form-field>


                                <mat-form-field appearance="outline" class="w-50 ps-1">
                                  <mat-label>{{'pass.buttons.cornerRadius' | translate}}</mat-label>
                                  <input formControlName="submitButtonStyle_cornerRadius" type="number" step="0.1" min="0" matInput placeholder="{{'pass.buttons.cornerRadius' | translate}}" data-nar="form-widget-button-corner-radius">
                                  <span matSuffix class="p-3"> px</span>
                                </mat-form-field>

                              </div>

                              <div class="list-group ">
                                <div class="list-group-item">
                                  <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                                    <span class="w-50 bg-white" >{{'pass.buttons.backgroundColor' | translate}}</span>
                                    <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                                      <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="submitButtonStyle_backgroundColor" style="margin-left:10px;" data-nar="form-widget-button-color-background"></ngx-colors>
                                      @if (invalid_backgroundColor) {
                                        <span id="invalid_backgroundColor" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                                      }
                                    </label>
                                  </div>
                                </div>

                                <div class="list-group-item">
                                  <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                                    <span class="w-50 bg-white" >{{'pass.buttons.borderColor' | translate}}</span>

                                    <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                                      <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="submitButtonStyle_borderColor" style="margin-left:10px;" data-nar="form-widget-button-color-border"></ngx-colors>
                                      @if (invalid_borderColor) {
                                        <span id="invalid_borderColor" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                                      }
                                    </label>
                                  </div>
                                </div>

                                <div class="list-group-item">
                                  <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                                    <span class="w-50 bg-white" >{{'pass.buttons.foregroundColor' | translate}}</span>

                                    <div class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                                      <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="submitButtonStyle_foregroundColor" style="margin-left:10px;" data-nar="form-widget-button-color-foreground"></ngx-colors>
                                      @if (invalid_foregroundColor) {
                                        <span id="invalid_foregroundColor" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            <!-- </form> -->
                          </div>
                        </mat-tab>
                      </mat-tab-group>

                      <div [app-widget-styling] = "{'form':formEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesStyle($event)"></div>

                    </form>
                    <div [app-widget-edit-filters] = "{'form':formEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>
                  </section>
